import { render } from "./SiteViewer.vue?vue&type=template&id=205f089c&scoped=true"
import script from "./SiteViewer.vue?vue&type=script&lang=js"
export * from "./SiteViewer.vue?vue&type=script&lang=js"

import "./SiteViewer.vue?vue&type=style&index=0&id=205f089c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205f089c"]])

export default __exports__